<template>
  <b-card no-body :class="{ 'card-transparent-background my-0 pt-0': type == 'view' || type == 'edit' }">
    <b-card-body :class="{
      'p-2': type == 'register',
      'p-0': type == 'view' || type == 'edit',
    }">
      <div class="container" :class="{
        'mx-0': type == 'view' || type == 'edit',
      }">
        <b-row>
          <b-col sm="12">
            <b-form-group class="form-group-garden-help" :label="type != 'view' ? 'First Name*' : 'First Name'"
              label-for="first_name" :first_name="first_name" label-class="form-label-garden-help"
              :label-cols-xl="type != 'register' ? 3 : 12" :content-cols-xl="type != 'register' ? 9 : 12"
              :label-cols-lg="type != 'register' ? 4 : 12" :content-cols-lg="type != 'register' ? 8 : 12"
              :label-cols-md="type != 'register' ? 5 : 12" :content-cols-md="type != 'register' ? 7 : 12" label-cols="12"
              content-cols="12">
              <p class="error_validation_message_p_gardenhelp" v-if="invalid_first_name">
                Please enter first name
              </p>
              <b-form-input v-if="type == 'register' || type == 'edit'" id="first_name" name="first_name" class="form-control-garden-help"
                v-model="_first_name" :first_name="first_name" placeholder="Enter your first name"
                required></b-form-input>
              <span v-if="type == 'view'" class="form-control form-control-garden-help">
                {{ _first_name }}
              </span>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12">
            <b-form-group class="form-group-garden-help" :label="type != 'view' ? 'Last Name*' : 'Last Name'"
              label-for="last_name" :last_name="last_name" label-class="form-label-garden-help"
              :label-cols-xl="type != 'register' ? 3 : 12" :content-cols-xl="type != 'register' ? 9 : 12"
              :label-cols-lg="type != 'register' ? 4 : 12" :content-cols-lg="type != 'register' ? 8 : 12"
              :label-cols-md="type != 'register' ? 5 : 12" :content-cols-md="type != 'register' ? 7 : 12">
              <p class="error_validation_message_p_gardenhelp" v-if="invalid_last_name">
                Please enter last name
              </p>
              <b-form-input v-if="type == 'register' || type == 'edit'" id="last_name" name="last_name" class="form-control-garden-help"
                v-model="_last_name" :last_name="last_name" placeholder="Enter your last name" required></b-form-input>
              <span v-if="type == 'view'" class="form-control form-control-garden-help">
                {{ _last_name }}
              </span>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12">
            <b-form-group class="form-group-garden-help" :label="type != 'view' ? 'Email Address*' : 'Email Address'"
              label-for="email" :email="email" label-class="form-label-garden-help"
              :label-cols-xl="type != 'register' ? 3 : 12" :content-cols-xl="type != 'register' ? 9 : 12"
              :label-cols-lg="type != 'register' ? 4 : 12" :content-cols-lg="type != 'register' ? 8 : 12"
              :label-cols-md="type != 'register' ? 5 : 12" :content-cols-md="type != 'register' ? 7 : 12">
              <p class="error_validation_message_p_gardenhelp" v-if="invalid_email">
                Please enter email address
              </p>
              <p class="error_validation_message_p_gardenhelp" v-if="invalid_correct_email">
                The email is invalid
              </p>
              <b-form-input v-if="type == 'register'" id="email" name="email" class="form-control-garden-help"
                v-model="_email" type="email" @keydown.space.prevent placeholder="Enter your email" required></b-form-input>
              <span v-if="type == 'view' || type == 'edit'" class="form-control form-control-garden-help">
                {{ _email }}
              </span>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12">
            <b-form-group class="mobile-number-input-group-garden-help"
              :class="{ 'form-group-garden-help': type == 'view' || type == 'edit' }"
              :label="type != 'view' ? 'Phone Number*' : 'Phone Number'" label-for="phone_number"
              :phone_number="phone_number" label-class="form-label-garden-help"
              :label-cols-xl="type != 'register' ? 3 : 12" :content-cols-xl="type != 'register' ? 9 : 12"
              :label-cols-lg="type != 'register' ? 4 : 12" :content-cols-lg="type != 'register' ? 8 : 12"
              :label-cols-md="type != 'register' ? 5 : 12" :content-cols-md="type != 'register' ? 7 : 12">
              <p class="error_validation_message_p_gardenhelp" v-if="invalid_phone_number">
                Please enter phone number
              </p>
              <vue-tel-input v-if="type == 'register' || type == 'edit'" class="form-control form-control-garden-help"
                id="phone_number" name="phone" v-model="_phone_number" :defaultCountry="'' + country_code" :key="country_code"
                required></vue-tel-input>
              <span v-if="type == 'view'" class="form-control form-control-garden-help">
                {{ _phone_number }}
              </span>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="type == 'register'">
          <b-col sm="12" class="px-0">
            <PasswordValidation input_class="form-control-garden-help form-control-auth-garden-help"
              validation_ul_class="password-validation-ul-garden-help" form_group_class="form-group-garden-help"
              form_label_class="form-label-garden-help" :password.sync="_password" :invalid_password="invalid_password"
              :invalid_correct_password="invalid_correct_password"
              error_message_class="error_validation_message_p_gardenhelp" />
          </b-col>
        </b-row>
        <b-row v-if="type == 'register'"><!--need handle condition to let contractor change his password only-->
          <b-col sm="12" class="px-0">
            <ConfirmPasswordValidation input_class="form-control-garden-help form-control-auth-garden-help"
              validation_ul_class="password-validation-ul-garden-help" form_group_class="form-group-garden-help"
              form_label_class="form-label-garden-help" :confirm_password.sync="_confirm_password"
              :invalid_confirm_password="invalid_confirm_password"
              :invalid_correct_confirm_password="invalid_correct_confirm_password" :password="_password"
              error_message_class="error_validation_message_p_gardenhelp" />
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12">
            <b-form-group class="form-group-garden-help" label="Address" label-for="address"
              label-class="form-label-garden-help" :label-cols-xl="type != 'register' ? 3 : 12"
              :content-cols-xl="type != 'register' ? 9 : 12" :label-cols-lg="type != 'register' ? 4 : 12"
              :content-cols-lg="type != 'register' ? 8 : 12" :label-cols-md="type != 'register' ? 5 : 12"
              :content-cols-md="type != 'register' ? 7 : 12">

              <p v-if="invalid_address" class="error_validation_message_p_gardenhelp">
                Please enter address
              </p>
              <p v-if="invalid_address_longitude || invalid_address_latitude"
                class="error_validation_message_p_gardenhelp">
                Please select correct address
              </p>
              <gmap-autocomplete v-if="type == 'register' || type == 'add' || type == 'edit'" @place_changed="updatePlace"
                class="form-control form-control-garden-help h-auto" :country="map_countries" id="address_input"
                name="address" placeholder="Address" @input="onInput" :componentRestrictions="componentRestrictions" :value="_address">
              </gmap-autocomplete>
              <input type="text" class="d-none" name="longitude" :value="dropoff_longitude">
              <input type="text" class="d-none" name="latitude" :value="dropoff_latitude">
              <span v-if="type == 'view'" class="form-control form-control-garden-help">
                {{ _address }}
              </span>
            </b-form-group>
          </b-col>
        </b-row>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
import $ from 'jquery'
import PasswordValidation from "@/components/Inputs/PasswordValidation.vue";
import ConfirmPasswordValidation from "@/components/Inputs/ConfirmPasswordValidation.vue";

export default {
  name: "PersonalInfo",
  components: { PasswordValidation, ConfirmPasswordValidation },
  props: [
    "type",
    "first_name",
    "invalid_first_name",
    "last_name",
    "invalid_last_name",
    "email",
    "invalid_email",
    "invalid_correct_email",
    "phone_number",
    "invalid_phone_number",
    "password",
    "invalid_password",
    "invalid_correct_password",
    "confirm_password",
    "invalid_confirm_password",
    "invalid_correct_confirm_password",

    "address",
    "longitude",
    "latitude",
    "invalid_address",
    "invalid_address_longitude",
    "invalid_address_latitude",
    "country",
    "county",
    "city", "country_code"
  ],
  data() {
    return {
      // address: null,
      // longitude: null,
      // latitude: null,
      map_countries: ["ie", "gb", "eg"],
      componentRestrictions: {},
      adddress: null,
      dropoff_latitude: null,
      dropoff_longitude: null

    };
  },
  updated() { },

  beforeMount() {
    let map_countries_str = process.env.MAP_COUNTRIES;
    this.map_countries = map_countries_str.split(",");
    // console.log(this.map_countries);
    this.componentRestrictions.country = map_countries_str.split(",");
    // console.log(this.componentRestrictions);

  },
  watch:{
    country_code(newval){
      console.log("change country code", newval)
      this._phone_number = null
    }
  },
  mounted() { },
  computed: {
    _first_name: {
      get() {
        return this.first_name;
      },
      set(value) {
        this.$emit("update:first_name", value);
      },
    },
    _last_name: {
      get() {
        return this.last_name;
      },
      set(value) {
        this.$emit("update:last_name", value);
      },
    },
    _email: {
      get() {
        return this.email;
      },
      set(value) {
        this.$emit("update:email", value);
      },
    },
    _phone_number: {
      get() {
        return this.phone_number;
      },
      set(value) {
        this.$emit("update:phone_number", value);
      },
    },
    _password: {
      get() {
        return this.password;
      },
      set(value) {
        this.$emit("update:password", value);
      },
    },
    _confirm_password: {
      get() {
        return this.confirm_password;
      },
      set(value) {
        this.$emit("update:confirm_password", value);
      },
    },

    _address: {
      get() {
        return this.address;
      },
      set(value) {
        this.$emit("update:address", value);
      },
    },
    _longitude: {
      get() {
        return this.longitude;
      },
      set(value) {
        this.$emit("update:longitude", value);
      },
    },
    _latitude: {
      get() {
        return this.latitude;
      },
      set(value) {
        this.$emit("update:latitude", value);
      },
    },

    _country: {
      get() {
        return this.country;
      },
      set(value) {
        this.$emit("update:country", value);
      },
    },
    _county: {
      get() {
        return this.county;
      },
      set(value) {
        this.$emit("update:county", value);
      },
    },
    _city: {
      get() {
        return this.city;
      },
      set(value) {
        this.$emit("update:city", value);
      },
    },
  },
  methods: {
    // checkvalidate(phone, isvalid) {
    //   console.log("check phone", phone, isvalid);
    // },
    onInput(value) {
      // console.log(value);
      // console.log($("#address_input").val())
      // console.log(this._address)
      this.$emit("update:address", $("#address_input").val());
      if ($("#address_input").val() == '') {
        this.$emit("update:latitude", null);
        this.$emit("update:longitude", null);
        this.$emit("update:country", null);
        this.$emit("update:county", null);
        this.$emit("update:city", null);
      }


    },
    updatePlace(place) {
      console.log(place);
      $("#address_input").val(place.formatted_address);
      //   this.$emit("update:dropoff_eircode", place.name);
      this.$emit("update:address", place.formatted_address);
      console.log(place.geometry.location.lat());
      console.log(place.geometry.location.lng());
      this.dropoff_latitude = place.geometry.location.lat();
      this.$emit("update:latitude", place.geometry.location.lat());
      this.dropoff_longitude = place.geometry.location.lng();
      this.$emit("update:longitude", place.geometry.location.lng());

      for (let i = 0; i < place.address_components.length; i++) {
        let item = place.address_components[i]
        console.log(item)
        if (item.types[0] == 'country') {
          console.log("country", item.long_name)
          this._country = item.long_name
        }
        else if (item.types[0] == 'administrative_area_level_1') {
          console.log("county", item.long_name)
          this._county = item.long_name
        }
        else if (item.types[0] == 'locality' ||
          item.types[0] == 'administrative_area_level_2') {
          console.log("city", item.long_name)
          this._city = item.long_name
        }
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/projects/garden_help/contractor/profile_details_components/PersonalInfo.vue